import { LuCloudUpload, LuPlay } from 'react-icons/lu';
import { Button } from '../../ui/Button';
import { useStrings } from '../../tenant/TenantProvider';
import { MODIFIER } from './CodeEditor';

const seconds = (ms) => Math.ceil(ms / 1000);

export function RunSubmitButtons({ canAct, running, submitting, runCooldownMs, submitCooldownMs, onRun, onSubmit }) {
  const t = useStrings();
  return (
    <div className="run-submit">
      <Button
        icon={LuPlay}
        onClick={onRun}
        loading={running}
        disabled={!canAct || submitting || runCooldownMs > 0}
        title={t('workspace.runShortcut', { mod: MODIFIER })}
      >
        {running ? t('workspace.running') : runCooldownMs > 0 ? t('workspace.runWithCooldown', { seconds: seconds(runCooldownMs) }) : t('workspace.run')}
      </Button>
      <Button
        variant="primary"
        icon={LuCloudUpload}
        data-celebrate-origin
        onClick={onSubmit}
        loading={submitting}
        disabled={!canAct || running || submitCooldownMs > 0}
        title={t('workspace.submitShortcut', { mod: MODIFIER })}
      >
        {submitting
          ? t('workspace.judging')
          : submitCooldownMs > 0
            ? t('workspace.submitWithCooldown', { seconds: seconds(submitCooldownMs) })
            : t('workspace.submit')}
      </Button>
    </div>
  );
}
